import { GET_ACCOUNT } from '../actionTypes/GetAccountTypes';

export const getAccount = (payload) => ({
    type: GET_ACCOUNT,
    payload,
});

export default getAccount;
